import { Container, Box, Typography, Divider } from "@mui/material";
import React from "react";
import ContainerTitle from "../../components/ContainerTitle/ContainerTitle";
import "../Experience/Experience.scss";
import mernStack from "../../assets/images/mern-stack.png";

const Experience = () => {
  return (
    <Container className="experience">
      <ContainerTitle title="Experience" />
      <Box className="experience-card">
        <Typography fontSize={23} fontWeight={600}>
          Full&nbsp;&nbsp;
          <span className="hover-color years"> Stack </span>
          &nbsp;Developer.
        </Typography>
        <img className="mern-image" src={mernStack} />
      </Box>
      <Divider sx={{ marginTop: 8 }} />
    </Container>
  );
};

export default Experience;
